<app-story-box *ngFor="let  summary of summaries" [summary]="summary"> </app-story-box>
